import React from 'react'
import { searchDicByValue, searchStyleByValue } from '../../utils/dictionary'

export const Badge = ({ data,className='' }) => {
    return (
        <div className={`${searchStyleByValue(data)} rounded font-semibold px-2 py-1 ${className}`}>{searchDicByValue(data)}</div>
    )
}
